import React from 'react';
import IconButton from './IconButton';

const EditButton = ({ disabled, entity, onClick }) => (
  <IconButton
    className="aridhia-edit-button"
    disabled={disabled}
    icon
    iconName="pencil"
    iconOnly
    iconClassName="primary"
    messageId={`actions.edit.${entity}.title`}
    onClick={onClick}
  />
);

export default EditButton;
